import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Slot } from "../types/slots";

interface SelectedItem {
  itemId: string;
  slot: Slot;
}

interface OrderStore {
  personCount: number;
  setPersonCount: (quantity: number) => void;
  selectedDate: Date | null;
  setSelectedDate: (date: Date | null) => void;
  selectedItem: SelectedItem | null;
  setSelectedItem: (item: SelectedItem | null) => void;
}

export const useOrderStore = create<OrderStore>()(
  persist(
    (set) => ({
      personCount: 0,
      setPersonCount: (quantity: number) => set({ personCount: quantity }),
      selectedDate: null,
      setSelectedDate: (date: Date | null) => set({ selectedDate: date }),
      selectedItem: null,
      setSelectedItem: (item: SelectedItem | null) => set({ selectedItem: item }),
    }),
    {
      name: "order-store",
      partialize: (state) => ({
        personCount: state.personCount,
        selectedDate: state.selectedDate,
      }),
      merge: (persisted, current) => {
        const p = persisted as { personCount?: number; selectedDate?: string | null };
        return {
          ...current,
          personCount: 'personCount' in p ? p.personCount! : current.personCount,
          selectedDate: p.selectedDate ? new Date(p.selectedDate) : null,
        };
      },
    },
  ),
);
